import { SpinnerCircle } from '@companio/companio_ui';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { Slide, ToastContainer, TypeOptions } from 'react-toastify';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import ErrorIcon from '@/assets/icons/icon_popup_error_new_version.svg?react';
import SuccessIcon from '@/assets/icons/success_icon.svg?react';
import AlertIcon from '@/assets/icons/alert_circle.svg?react';
import InfoIcon from '@/assets/icons/icon_popup_info_new_version.svg?react';
import { TOAST_AUTO_CLOSE_DURATION } from '@/constants/user_interface';
import { Router } from './Router';
import { GlobalStyle } from './styles/global';
import { defaultTheme } from './styles/themes/default';
import { AuthContextProvider } from './contexts/AuthContext';
import { AnnualReportLockModal } from './components/AnnualReportLockModal/AnnualReportLockModal';
import { ChunkErrorBoundary } from './components/ChunkErrorBoundary/ChunkErrorBoundary';

import 'react-tooltip/dist/react-tooltip.css';
import 'react-toastify/dist/ReactToastify.css';
import 'flag-icons/css/flag-icons.min.css';
import { TourContextProvider } from './contexts/TourContext';

const queryClient = new QueryClient();

export function App() {
  const isDevelopmentMode = import.meta.env.DEV;

  return (
    <ThemeProvider theme={defaultTheme}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthContextProvider>
            <TourContextProvider>
              <ChunkErrorBoundary>
                <Router />
              </ChunkErrorBoundary>
              <AnnualReportLockModal />
              <ToastContainer
                position="bottom-right"
                transition={Slide}
                autoClose={TOAST_AUTO_CLOSE_DURATION}
                icon={({ type, isLoading }) => {
                  if (isLoading) {
                    return <SpinnerCircle />;
                  }

                  switch (type as TypeOptions) {
                    case 'info':
                      return <InfoIcon />;
                    case 'error':
                      return <ErrorIcon />;
                    case 'success':
                      return <SuccessIcon />;
                    case 'warning':
                      return <AlertIcon />;
                    default:
                      return null;
                  }
                }}
              />
            </TourContextProvider>
          </AuthContextProvider>
        </BrowserRouter>
        <GlobalStyle />
        {isDevelopmentMode && (
          <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
        )}
      </QueryClientProvider>
    </ThemeProvider>
  );
}
